module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner-area"
  }, [_c('el-carousel', {
    staticStyle: {
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "interval": 5000,
      "trigger": "click",
      "height": "70vh"
    }
  }, _vm._l((_vm.list.position1), function(item, index) {
    return _c('el-carousel-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.list.position1.length > 0),
        expression: "list.position1.length>0"
      }],
      key: index
    }, [_c('div', {
      staticClass: "banner-area-img",
      style: ({
        width: '100%',
        height: '100%',
        'background-image': 'url(' + item.thumb + ')',
        'background-repeat': 'no-repeat',
        'background-size': '100% 100%'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "new-banner-text"
    }, [_c('div', {
      staticClass: "new-banner-title"
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.brief))])]), _vm._v(" "), (item.content != null) ? _c('div', {
      staticClass: "new-banner-brief",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }) : _vm._e()])])
  }), 1)], 1), _vm._v(" "), (_vm.list.position2.length > 0) ? _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "banner-item"
  }, [_c('div', {
    staticClass: "row max-height"
  }, [_c('div', {
    staticClass: "col-lg-3 offset-xl-1 align-self-center"
  }, [_c('div', {
    staticClass: "banner-about color-content"
  }, [_c('h2', {
    staticClass: "color-title"
  }, [_vm._v("Solution")]), _vm._v(" "), _c('h2', {
    staticClass: "color-title"
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('b', {
    staticClass: "slot-about"
  }), _vm._v(" "), (_vm.list.position2.length > 0) ? _c('p', {
    staticClass: "py-3"
  }, [_vm._v(_vm._s(_vm.list.position2[0].brief))]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 0) ? _c('el-button', {
    staticStyle: {
      "background-color": "#232126",
      "color": "#FFFFFF",
      "border": "1px solid #999999"
    },
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[0].id)
      }
    }
  }, [_vm._v("查看更多")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 px-5"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.list.position2.length > 1) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[1].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[1].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[1].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[1].brief))])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 2) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[2].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[2].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[2].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[2].brief))])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 3) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[3].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[3].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[3].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[3].brief))])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 4) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[4].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[4].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[4].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[4].brief))])])])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position3.length > 0) ? _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "banner-three"
  }, [_c('div', {
    staticClass: "banner-compony-layout"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "3vh",
      "color": "#fff",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.list.position3[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 align-self-center"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 banner-compony-content"
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-indent": "2em"
    }
  }, [_vm._v(_vm._s(_vm.list.position3[0].brief) + " ")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 offset-xl-6 align-self-center"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi2",
    staticStyle: {
      "height": "35vh"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.list.position3[0].thumb
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position4.length > 0) ? _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "banner-four top_img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.list.position4[0].thumb
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn color-about",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "flaticon-next"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-311b63bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/new-home.vue
// module id = 289
// module chunks = 1